const testimonialToggles = document.querySelectorAll('.testimonial-card__toggle');

function handleToggleClick(event) {
	event.preventDefault();
	const button = event.currentTarget;
	const card = button.closest('.testimonial-card');

	if (!card) {
		return;
	}

	const content = document.getElementById(button.getAttribute('aria-controls'));

	const isExpanded = card.classList.toggle('testimonial-card--expanded');

	button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

	if (content) {
		content.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
	}
}

testimonialToggles.forEach((toggle) => {
	toggle.addEventListener('click', handleToggleClick);
});
